// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__P3VjB","content":"styles_content__2y3I4","moreInfo":"styles_moreInfo__bNLFy","row":"styles_row__2IzUZ","header":"styles_header__3VRxe"};